module.exports = __webpack_public_path__ + "static/media/foto.43e107ea.jpeg";